import { HttpClient } from './http-client';
import { 
  OrganizationSettings,
  UpdateOrganizationSettingsRequest,
  OrganizationSettingsImportRequest,
  OrganizationSettingsImportResult,
  ApiError
} from '../types';

export class OrganizationService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get organization settings
   */
  async getOrganizationSettings(): Promise<OrganizationSettings> {
    return this.httpClient.get<OrganizationSettings>('/api/v1/organization/settings');
  }

  /**
   * Update organization settings
   */
  async updateOrganizationSettings(request: UpdateOrganizationSettingsRequest): Promise<OrganizationSettings> {
    return this.httpClient.put<OrganizationSettings>('/api/v1/organization/settings', request);
  }

  /**
   * Export organization settings as a JSON blob (triggers file download in the browser).
   * The SMTP password is excluded from the export.
   */
  async exportOrganizationSettings(): Promise<Blob> {
    return this.httpClient.getBlob('/api/v1/organization/settings/export');
  }

  /**
   * Import organization settings from a previously-exported file.
   */
  async importOrganizationSettings(
    request: OrganizationSettingsImportRequest
  ): Promise<OrganizationSettingsImportResult> {
    return this.httpClient.post<OrganizationSettingsImportResult>(
      '/api/v1/organization/settings/import',
      request
    );
  }
}
